import {
    hasSavedMaterialConsumptions,
    sumMaterialConsumptionLengthKm,
} from '../../../pages/completed-print-jobs/helpers/consumption-helpers'
import MaterialConsumption from '../../../types/api/material-consumption'
import Shipment from '../../../types/api/shipment'

export function getShipmentMaterialConsumptions(
    shipment?: Shipment | null
): MaterialConsumption[] {
    return shipment?.print_job?.material_consumptions || []
}

export function hasShipmentMaterialConsumptions(shipment?: Shipment | null): boolean {
    const printJob = shipment?.print_job
    return Boolean(printJob && hasSavedMaterialConsumptions(printJob))
}

export function getShipmentActualMaterialLengthKm(
    shipment?: Shipment | null
): number | undefined {
    if (!hasShipmentMaterialConsumptions(shipment)) {
        return undefined
    }

    return sumMaterialConsumptionLengthKm(getShipmentMaterialConsumptions(shipment))
}

/** Ширины фактических материалов расхода (уникальные, по возрастанию). */
export function getShipmentActualMaterialWidths(shipment?: Shipment | null): number[] {
    const widths = getShipmentMaterialConsumptions(shipment)
        .map(item => item.material?.width)
        .filter((width): width is number => width != null)

    return [...new Set(widths)].sort((a, b) => a - b)
}
